export default "__VITE_ASSET__6U9g4Vk4__"